;(function() {
/* @ngInject */
function MojaFirmaLauncher() {
    return {
        restrict: 'E',
        templateUrl: "/app/shared/moja-firma-launcher/moja-firma-launcher.html",
        controller: "MojaFirmaLauncherController",
        controllerAs: 'vm',
        bindToController: true
    };
}

/* @ngInject */
function MojaFirmaLauncherController(UserService, $filter, $rootScope, $scope, MojaFirmaService) {
    let vm = this;
    let server = UserService;

    vm.loggedUser = {};
    vm.showData = "";

    vm.goToMojaFirma = goToMojaFirma;

    server.getLoggedUser().then(onLoggedUserLoad);

    $scope.$on('user-changed-contact', function (event, args) {
        server.getLoggedUser().then(onLoggedUserLoad);
    });

    function onLoggedUserLoad(user) {
        vm.loggedUser = user;
        onUserChange();
    }

    function goToMojaFirma() {
        MojaFirmaService.goToMojaFirma("objednavky");
    }

    function onUserChange() {
        if (vm.loggedUser && vm.loggedUser.firstName) {
            vm.showData = vm.loggedUser.firstName + " " + vm.loggedUser.lastName;
        } else if (vm.loggedUser && vm.loggedUser.email) {
            vm.showData = vm.loggedUser.email;
        }
    }

}

angular.module("firmaren")
    .controller("MojaFirmaLauncherController", MojaFirmaLauncherController)
    .directive("mojaFirmaLauncher", MojaFirmaLauncher);
}());
